import {
  Box,
  Heading,
  HStack,
  Icon,
  Text,
  Input,
  VStack,
} from "@chakra-ui/react";
import { useConnectedSystem } from "./useConnectedSystem";
import { MdEditOff, MdModeEdit, MdSave } from "react-icons/md";
import { GrSystem } from "react-icons/gr";
import { DropDown } from "../../components/Select/DropDown";

export const ConnectedSystem = () => {
  const {
    selectedConnectedSystem,
    selectedConnectedSystemAuth,
    isEditing,
    isEdited,
    authsOptions,
    onEditToggle,
    onAuthChange,
    onAuthValueChange,
    onChange,
    onSave,
  } = useConnectedSystem();

  return (
    <Box>
      <Box
        bg="rgba(255, 255, 255, 0.05)"
        backdropFilter="blur(20px)"
        borderRadius="20px"
        border="1px solid rgba(255, 255, 255, 0.1)"
        p={6}
      >
        <HStack justifyContent="space-between">
          <HStack>
            <Icon
              as={GrSystem as React.ElementType}
              color="orange.400"
              boxSize="24px"
            />
            <Heading fontSize="24px" color="white">{selectedConnectedSystem?.csNm}</Heading>
          </HStack>
          <HStack>
            <Icon
              as={
                isEditing
                  ? (MdEditOff as React.ElementType)
                  : (MdModeEdit as React.ElementType)
              }
              onClick={onEditToggle}
              cursor="pointer"
              boxSize="20px"
              color="rgba(255, 255, 255, 0.8)"
              _hover={{ color: "brand.400" }}
            />
            {isEdited ? (
              <Icon
                as={MdSave as React.ElementType}
                cursor="pointer"
                boxSize="20px"
                onClick={onSave}
                color="green.400"
                _hover={{ color: "green.300" }}
              />
            ) : null}
          </HStack>
        </HStack>
      </Box>
      <Box
        bg="rgba(255, 255, 255, 0.05)"
        backdropFilter="blur(20px)"
        borderRadius="20px"
        border="1px solid rgba(255, 255, 255, 0.1)"
        mt={4}
        p={6}
      >
        <VStack spacing={4} align="start">
          <HStack width="100%">
            <Text fontWeight="bold" width="30%" color="white">
              System Name:
            </Text>
            <Input
              value={selectedConnectedSystem?.csNm || ""}
              placeholder="System Name"
              onChange={(e) => onChange("csNm", e.target.value)}
              isReadOnly={!isEditing}
              focusBorderColor={"brand.500"}
            />
          </HStack>
          <HStack width="100%">
            <Text fontWeight="bold" width="30%" color="white">
              Description:
            </Text>
            <Input
              value={selectedConnectedSystem?.csDesc || ""}
              placeholder="Description"
              onChange={(e) => onChange("csDesc", e.target.value)}
              isReadOnly={!isEditing}
              focusBorderColor={"brand.500"}
            />
          </HStack>
          <HStack width="100%">
            <Text fontWeight="bold" width="30%" color="white">
              Base URL:
            </Text>
            <Input
              value={selectedConnectedSystem?.baseUrl || ""}
              placeholder="Base URL"
              onChange={(e) => onChange("baseUrl", e.target.value)}
              isReadOnly={!isEditing}
              focusBorderColor={"brand.500"}
            />
          </HStack>
          <HStack width="100%">
            <Text fontWeight="bold" width="30%" color="white">
              Authentication Type:
            </Text>
            <DropDown
              selected={{
                id: selectedConnectedSystemAuth?.authCd as string,
                name: selectedConnectedSystemAuth?.authNm as string,
                component: <Text>{selectedConnectedSystemAuth?.authNm}</Text>,
              }}
              title={<Text></Text>}
              options={authsOptions}
              onOptionChange={(option) => {
                if (!Array.isArray(option)) {
                  onAuthChange(option.id);
                }
              }}
              disabled={!isEditing}
            />
          </HStack>
          {selectedConnectedSystemAuth?.authProps.map((prop) => (
            <HStack width="100%" key={prop.authPropCd}>
              <Text fontWeight="bold" width="30%" color="white">
                {prop.authPropNm}:
              </Text>
              <Input
                value={
                  selectedConnectedSystem?.systemAuth.find(
                    (auth) => auth.authPropCd === prop.authPropCd
                  )?.authPropVal || ""
                }
                placeholder={prop.authPropNm}
                onChange={(e) =>
                  onAuthValueChange(prop.authPropCd, e.target.value)
                }
                isReadOnly={!isEditing}
                focusBorderColor={"brand.500"}
              />
            </HStack>
          ))}
        </VStack>
      </Box>
    </Box>
  );
};
